import { Link } from "react-router-dom";
import { IFullPlanDetail, IFullPlanDetailPPO } from "../../interfaces/api";
import { Tooltip } from "react-tooltip";
import { EnrollTooltip } from "../../shared";
import { useZipRootLoaderData } from "../../hooks/useZipRootLoaderData";
import { useEnrollLink } from "../../hooks/useEnrollLink";

interface ICompareStick {
  data: IFullPlanDetail | IFullPlanDetailPPO;
  footer?: boolean;
}

const CompareStickRecommend: React.FC<ICompareStick> = (data) => {
  const { yearsForZip } = useZipRootLoaderData();

  const pbpid = data.data.PlanDetails[0].company[0].healthPlan[0].pbp[0].id;
  const hcode = data.data.PlanDetails[0].company[0].healthPlan[0].hCode;

  const enrollmentLink = useEnrollLink(
    pbpid,
    hcode,
    `${data.data.PlanDetails[0].planYear}`
  );

  const planYear = yearsForZip.find(
    (item) => item.Year === Number(data.data.PlanDetails[0].planYear)
  );

  const goEnroll = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    window.open(enrollmentLink, "_blank");
  };

  return (
    <div
      className="hide-for-small-only compare-item"
      style={{
        padding: "20px",
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      {!data.footer && (
        <div
          className="secondary-color text-uppercase font-weight-600 compare-title"
          style={{
            fontFamily: "franklin-gothic-condensed,sans-serif",
            fontSize: "30px",
            textAlign: "left",
            paddingBottom: 8,
            overflow: "auto",
          }}
        >
          {data.data.PlanDetails[0].company[0].healthPlan[0].pbp[0].name}{" "}
          {data.data.PlanDetails[0].company[0].healthPlan[0].pbp[0].id}
        </div>
      )}
      <p
        style={{
          marginTop: "auto",
          marginBottom: "0",
        }}
      >
        <Link
          to={{
            pathname: "/plan-details",
            search: `?hcode=${hcode}&pbpid=${pbpid}`,
          }}
          className="color-primary text-underline"
          style={{
            fontSize: "25px",
            marginBottom: 25,
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          View Details
        </Link>
      </p>
      <button
        type="button"
        className="button my-anchor-element enroll-button"
        disabled={!planYear?.canEnroll}
        style={{
          flex: 1,
          width: "100%",
          minHeight: "60px",
          maxHeight: "55px",
          marginRight: 8,
          backgroundColor: !planYear?.canEnroll ? "#CACACA" : "",
        }}
        onClick={goEnroll}
      >
        Enroll
      </button>
      {!planYear?.canEnroll && planYear?.shouldDisplay && (
        <Tooltip
          anchorSelect=".enroll-button"
          place="top"
          style={{
            width: "75%",
            maxWidth: "600px",
            backgroundColor: "#F5F9FD",
            color: "black",
            padding: 28,
          }}
        >
          <EnrollTooltip />
        </Tooltip>
      )}
    </div>
  );
};

export default CompareStickRecommend;
